var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.expired)?_c('router-view'):_vm._e()],1),(_vm.expired)?_c('div',{staticStyle:{"width":"100%","height":"100%","display":"flex","align-items":"center","justify-content":"center"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }